// b = a.replaceAll(/\n+/g, '\n').replaceAll(/\t+/g, '\t').trim()

export type Sentence = {
  word: string;
  wordPhonetic?: string;
  sentence: string;
  sentencePhonetic: string;
  note?: string;
};

export const kitList = {
  title: "Voice - Kit list sentences",
  sections: [
    {
      title: "Vowels",
      sentences: [
        {
          word: "Kit",
          wordPhonetic: "kɪt",
          sentence:
            "The ship listed as the busy women built a pretty bridge in the dim mid-winter",
          sentencePhonetic:
            "ðə ʃɪp ˈlɪstɪd æz ðə ˈbɪzi ˈwɪmɪn bɪlt ə ˈprɪti brɪʤ ɪn ðə dɪm ˈmɪdˈwɪntə",
        },
        {
          word: "Dress",
          wordPhonetic: "drɛs",
          sentence:
            "In a sweat, Jeff edged his head into the Thames in an effort to save his best friend from the treacherous bell of death",
          sentencePhonetic:
            "ɪn ə swɛt, ʤɛf ɛʤd hɪz hɛd ˈɪntuː ðə tɛmz ɪn ən ˈɛfət tuː seɪv hɪz bɛst frɛnd frɒm ðə ˈtrɛʧᵊrəs bɛl ɒv dɛθ",
        },
        {
          word: "Strut",
          wordPhonetic: "strʌt",
          sentence:
            "The dull young monks rushed in a flood to hunt the buds of the lovely buttercup",
          sentencePhonetic:
            "ðə dʌl jʌŋ mʌŋks rʌʃt ɪn ə flʌd tuː hʌnt ðə bʌdz ɒv ðə ˈlʌvli ˈbʌtəkʌp",
        },
        {
          word: "Foot",
          wordPhonetic: "fʊt",
          sentence:
            "The woman shouldn’t put the full pudding onto the butchers hook",
          sentencePhonetic:
            "ðə ˈwʊmən ˈʃʊdᵊnt pʊt ðə fʊl ˈpʊdɪŋ ˈɒntuː ðə ˈbʊʧəz hʊk",
        },
        {
          word: "Goose",
          wordPhonetic: "ɡuːs",
          sentence:
            "Two beautiful youths moved through a few smooth, juicy, rude grooves in feudal confusion",
          sentencePhonetic:
            "tuː ˈbjuːtɪfᵊl juːθs muːvd θruː ə fjuː smuːð, ˈʤuːsi, ruːd ɡruːvz ɪn ˈfjuːdᵊl kənˈfjuːʒᵊn",
        },
        {
          word: "Fleece",
          wordPhonetic: "fliːs",
          sentence:
            "The police had reason to believe that Peter, Keith and the anaemic Sheila could be in league to illegally deceive people",
          sentencePhonetic:
            "ðə pəˈliːs hæd ˈriːzᵊn tuː bɪˈliːv ðæt ˈpiːtə, kiːθ ænd ði əˈniːmɪk ˈʃiːlə kʊd biː ɪn liːɡ tuː ɪˈliːɡᵊli dɪˈsiːv ˈpiːpᵊl",
        },
        {
          word: "Nurse",
          wordPhonetic: "nɜːs",
          sentence:
            "Pearl urged Myrtle’s attorney to rehearse a certain circus turn before the courteous worm turned",
          sentencePhonetic:
            "pɜːl ɜːʤd ˈmɜːtᵊlz əˈtɜːni tuː rɪˈhɜːs ə ˈsɜːtᵊn ˈsɜːkəs tɜːn bɪˈfɔː ðə ˈkɜːtiəs wɜːm tɜːnd",
        },
        {
          word: "Trap",
          wordPhonetic: "træp",
          sentence: "The cat dashed to catch the ham that dangled from the bag",
          sentencePhonetic:
            "ðə kæt dæʃt tuː kæʧ ðə hæm ðæt ˈdæŋɡᵊld frɒm ðə bæɡ",
        },
        {
          word: "Bath",
          wordPhonetic: "bɑːθ",
          sentence:
            "Francis the calf can’t dance, laughed Sandra the giraffe, aghast, as the calf pranced disastrously.",
          sentencePhonetic:
            "ˈfrɑːnsɪs ðə kɑːf kɑːnt dɑːns, lɑːft ˈsændrə ðə ʤɪˈrɑːf, əˈɡɑːst, æz ðə kɑːf prɑːnst dɪˈzɑːstrəsli.",
          note: `t in can't is not pronounced`,
        },
        {
          word: "Palm",
          wordPhonetic: "pɑːm",
          sentence: "Brahms sonata kept father calm in the spa",
          sentencePhonetic: "Brahms səˈnɑːtə kɛpt ˈfɑːðə kɑːm ɪn ðə spɑː",
        },
        {
          word: "Start",
          wordPhonetic: "stɑːt",
          sentence:
            "Sergeant Charles was the star of the party with his hearty aria",
          sentencePhonetic:
            "ˈsɑːʤᵊnt ʧɑːlz wɒz ðə stɑːr ɒv ðə ˈpɑːti wɪð hɪz ˈhɑːti ˈɑːriə",
        },
        {
          word: "Lot",
          wordPhonetic: "lɒt",
          sentence:
            "Tom honestly acknowledged how top notch the swan was to dodge the yacht",
          sentencePhonetic:
            "tɒm ˈɒnɪstli əkˈnɒlɪʤd haʊ tɒp nɒʧ ðə swɒn wɒz tuː dɒʤ ðə jɒt",
        },
        {
          word: "Cloth",
          wordPhonetic: "klɒθ",
          sentence:
            "Ross often frothed the coffee and washed the long sausages in Boston",
          sentencePhonetic:
            "rɒs ˈɒfᵊn frɒθt ðə ˈkɒfi ænd wɒʃt ðə lɒŋ ˈsɒsɪʤɪz ɪn ˈbɒstᵊn",
          note: "what is the difference with lot?",
        },
        {
          word: "Thought",
          wordPhonetic: "θɔːt",
          sentence:
            "Paul applauded all the naughty daughters who yawned when taught with chalk and talk",
          sentencePhonetic:
            "pɔːl əˈplɔːdɪd ɔːl ðə ˈnɔːti ˈdɔːtəz huː jɔːnd wɛn tɔːt wɪð ʧɔːk ænd tɔːk",
        },
        {
          word: "North",
          wordPhonetic: "nɔːθ",
          sentence:
            "George cavorted with Thor to fortify his short torso for the war in York",
          sentencePhonetic:
            "ʤɔːʤ kəˈvɔːtɪd wɪð θɔː tuː ˈfɔːtɪfaɪ hɪz ʃɔːt ˈtɔːsəʊ fɔː ðə wɔːr ɪn jɔːk",
          note: "what is the difference with thought?",
        },
        {
          word: "Force",
          wordPhonetic: "fɔːs",
          sentence:
            "Of course I adore Nora, roared the porter through the door to the four divorced boarders",
          sentencePhonetic:
            "ɒv kɔːs aɪ əˈdɔː ˈnɔːrə, rɔːd ðə ˈpɔːtə θruː ðə dɔː tuː ðə fɔː dɪˈvɔːst ˈbɔːdəz",
          note: "what is the difference with thought?",
        },
        {
          word: "Face",
          wordPhonetic: "feɪs",
          sentence:
            "April felt faint as she campaigned to reign in the wasteful ladies to change their ways and obey",
          sentencePhonetic:
            "ˈeɪprᵊl fɛlt feɪnt æz ʃiː kæmˈpeɪnd tuː reɪn ɪn ðə ˈweɪstfᵊl ˈleɪdɪz tuː ʧeɪnʤ ðeə weɪz ænd əʊˈbeɪ",
        },
        {
          word: "Goat",
          wordPhonetic: "ɡəʊt",
          sentence:
            "Joan coaxed her beau, Owen, to grow bolder, though she loathed over-controlling soldiers",
          sentencePhonetic:
            "ʤəʊn kəʊkst hɜː bəʊ, ˈəʊɪn, tuː ɡrəʊ ˈbəʊldə, ðəʊ ʃiː ləʊðd ˌəʊvəkənˈtrəʊlɪŋ ˈsəʊlʤəz",
          note: "in loathed over, d is not pronounced",
        },
        {
          word: "Goal",
          wordPhonetic: "ɡəʊl",
          sentence: "The soul of the lonely mole evolved from the stoney hole",
          sentencePhonetic:
            "ðə səʊl ɒv ðə ˈləʊnli məʊl ɪˈvɒlvd frɒm ðə stoney həʊl",
          note: "what is the difference with goat?",
        },
        {
          word: "Price",
          wordPhonetic: "praɪs",
          sentence:
            "Friday is the right night to arrive by bicycle in Cyprus to buy a fine eiderdown",
          sentencePhonetic:
            "ˈfraɪdeɪ ɪz ðə raɪt naɪt tuː əˈraɪv baɪ ˈbaɪsɪkᵊl ɪn ˈsaɪprəs tuː baɪ ə faɪn ˈaɪdədaʊn",
        },
        {
          word: "Choice",
          wordPhonetic: "ʧɔɪs",
          sentence:
            "The boy employed a joist to hoist the moist oysters into the boiling oil",
          sentencePhonetic:
            "ðə bɔɪ ɪmˈplɔɪd ə ʤɔɪst tuː hɔɪst ðə mɔɪst ˈɔɪstəz ˈɪntuː ðə ˈbɔɪlɪŋ ɔɪl",
        },
        {
          word: "Mouth",
          wordPhonetic: "maʊθ",
          sentence:
            "The loud crowd from south of the county wanted to oust the clown out of town, but they were all mouth",
          sentencePhonetic:
            "ðə laʊd kraʊd frɒm saʊθ ɒv ðə ˈkaʊnti ˈwɒntɪd tuː aʊst ðə klaʊn aʊt ɒv taʊn, bʌt ðeɪ wɜːr ɔːl maʊθ",
        },
        {
          word: "Near",
          wordPhonetic: "nɪə",
          sentence:
            "Maria was sincere in her weird career but feared the fierce bearded cashier",
          sentencePhonetic:
            "məˈriə wɒz sɪnˈsɪər ɪn hɜː wɪəd kəˈrɪə bʌt fɪəd ðə fɪəs ˈbɪədɪd kæˈʃɪə",
        },
        {
          word: "Square",
          wordPhonetic: "skweə",
          sentence: "Where the pears are scarce, the bears share theirs fairly",
          sentencePhonetic: "weə ðə peəz ɑː skeəs, ðə beəz ʃeə ðeəz ˈfeəli",
        },
        {
          _note_:
            "Mispronounce Muriel/Muris at the beginning, forgot to edit it out",
          word: "Tour",
          wordPhonetic: "tʊə",
          sentence:
            "Muriel assured the poor tourists that the insurance was sure to cover Europe",
          sentencePhonetic:
            "ˈmjuːriəl əˈʃɔːd ðə pɔː ˈtʊərɪsts ðæt ði ɪnˈʃʊərᵊns wɒz ʃɔː tuː ˈkʌvə ˈjʊərəp",
        },
        {
          word: "Happy / Letter / Comma",
          wordPhonetic: "ˈhæpi / ˈlɛtə / ˈkɒmə",
          sentence:
            "Lucy was happy to receive a letter from Rebecca who lived in the city. The letter had no commas but she loved reading it.",
          sentencePhonetic:
            "ˈluːsi wɒz ˈhæpi tuː rɪˈsiːv ə ˈlɛtə frɒm rɪˈbɛkə huː lɪvd ɪn ðə ˈsɪti. ðə ˈlɛtə hæd nəʊ ˈkɒməz bʌt ʃiː lʌvd ˈriːdɪŋ ɪt.",
          note: "si:v in receive is not long, why, is it because of the continuation to 'a'",
        },
      ],
    },
    {
      title: "Consonants",
      sentences: [
        {
          word: "R",
          wordPhonetic: "",
          sentence:
            "Margaret, Linda and Gerry asked Peter if Roland started with ‘R’.",
          sentencePhonetic:
            "ˈmɑːɡᵊrət, ˈlɪndə ænd ˈʤɛri ɑːskt ˈpiːtər ɪf ˈrəʊlənd ˈstɑːtɪd wɪð ɑː.",
        },
        {
          word: "L",
          sentence:
            "Larry the lamb slept peacefully in the field until hailstones fell.",
          sentencePhonetic:
            "ˈlæri ðə læm slɛpt ˈpiːsfᵊli ɪn ðə fiːld ənˈtɪl ˈheɪlstəʊnz fɛl.",
          note: "s in hailstones is not very clear?",
        },
        {
          word: "H",
          sentence: "Harry Hobson had a holiday in Hawaii.",
          sentencePhonetic: "ˈhæri Hobson hæd ə ˈhɒlədeɪ ɪn həˈwaɪiː.",
        },
        {
          word: "NG",
          sentence: "The smiling singer was singing with the king.",
          sentencePhonetic: "ðə ˈsmaɪlɪŋ ˈsɪŋə wɒz ˈsɪŋɪŋ wɪð ðə kɪŋ.",
        },
        {
          word: "TH",
          sentence: "That’s my brother with a thermos of Matthew’s broth.",
          sentencePhonetic: "ðæts maɪ ˈbrʌðə wɪð ə ˈθɜːmɒs ɒv ˈmæθjuːz brɒθ.",
        },
        {
          word: "PTK",
          sentence: "He put the butter in the paper and gave it to the biker.",
          sentencePhonetic:
            "hiː pʊt ðə ˈbʌtər ɪn ðə ˈpeɪpər ænd ɡeɪv ɪt tuː ðə ˈbaɪkə.",
        },
      ],
    },
  ],
};

export type KitList = typeof kitList;
export type SentenceConfig = KitList["sections"][number]["sentences"][number];
